export const RadialChartStyle = {
    top: '35%',
    right: 36,
    transform: 'translate(0, -50%)',
    lineHeight: '20px',
    fontSize: '12px'
};
